import React, {Component, Fragment} from 'react';
import {Route, Link, withRouter} from 'react-router-dom';
import {Layout, Menu, Icon, Button, Modal, Divider} from 'antd';
import {Market, Exchange, TopList, Fund} from './containers';
import Logo from './svg/ministryofcoin_logo_light.svg';
import AltLogo from './svg/ministryofcoin_logo_dark.svg';
import LogoIcon from './svg/ministryofcoin_icon_light.svg';
import './App.css';
import {inject, observer} from "mobx-react";

const {Sider, Header, Footer} = Layout;
const SubMenu = Menu.SubMenu;

class WAnalytics extends Component {
  componentWillReceiveProps(props) {
    const path = props.location.pathname + props.location.search;
    if(props.main.location !== path) {
      props.main.location = path;
      if(window.ga) {
        window.ga('set', 'page', path);
        window.ga('send', 'pageview');
      }
    }
  }
  render() { return null; }
}
const Analytics = inject("main")(observer(WAnalytics));

/*
const Analytics = inject("main")(observer((props) => {
  const path = props.location.pathname + props.location.search;
  if(props.main.location !== path) {
    props.main.location = path;
    console.log('ga', props, { page: path })
  }
  //ReactGA.set();
  //ReactGA.pageview(props.location.pathname + props.location.search);
  return null;
}));
*/

class App extends Component {
  state = {
    collapsed: false
  };
  onCollapse = (collapsed) => {
    this.setState({collapsed});
  }
  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  //<Menu.Item key="profile">Profile</Menu.Item>
  /*
  <Menu.Item key="buyers-guide">
    <Icon type="compass"/>
    <span>Buyer's Guide</span>
  </Menu.Item>
  <Menu.Item key="market">
    <Link to="/market">
      <Icon type="dot-chart"/>
      <span>The Market</span>
    </Link>
  </Menu.Item>

  var AmCharts = require("@amcharts/amcharts3-react");
  */

  getAccountMenu = () => {
    if(this.props.main.authenticated) {
      return (
        <SubMenu key="account" title={<span><Icon type = "user" /><span>Account</span></span>}>
          <Menu.Item key="logout">Log Out</Menu.Item>
        </SubMenu>
      )
    } else {
      return (
        <Menu.Item key="login">
          <Icon type="user"/>
          <span>Login</span>
        </Menu.Item>
      )
    }
  }

  onMenuClick = (e) => {
    switch(e.key) {
      case 'login':
        this.props.main.login();
      break;
      case 'logout':
        this.props.main.logout()
      break;
      default:
    }
  }

  renderMenu() {
    let selected = this.props.location.pathname.split('/')[1]; if(selected === '') selected = 'home';
    return (
      <Menu theme="dark" defaultSelectedKeys={[selected]} selected={[selected]} mode="inline" onClick={this.onMenuClick}>
        <Menu.Item key="top">
          <Link to="/top">
            <Icon type="trophy"/>
            <span>Top 20 Coins</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="exchange">
          <Link to="/exchange">
            <Icon type="wallet"/>
            <span>Exchange</span>
          </Link>
        </Menu.Item>
        {this.getAccountMenu()}
      </Menu>
    )
  }

  render() {
    const altlogo = this.state.collapsed ? <img src={AltLogo} className="altLogo" alt="Ministry of Coin"/> : null;
    const top_account_menu = this.props.main.authenticated ? <Fragment><Button onClick={()=>{ this.props.main.logout() }} className="top_acc_menu">Log Out</Button><span className="top_acc_user">{this.props.main.auth_user.name}</span></Fragment>: <Button type="primary" icon="login" className="top_acc_menu" onClick={()=>{ this.props.main.login(); }}>Login</Button>
    return (
      <Layout key={this.props.location.pathname} style={{
          minHeight: '100vh'
        }}>
        <Sider collapsible="collapsible" collapsed={this.state.collapsed} onCollapse={this.onCollapse} breakpoint={'sm'}>
          <img src={this.state.collapsed
              ? LogoIcon
              : Logo} className="logo" alt="Ministry of Coin"/>
          {this.renderMenu()}
        </Sider>
        <Layout>
          <Header className="main-header">
            <Icon
              className="sidebar-trigger"
              type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
              onClick={this.toggle}
            />
            {top_account_menu}
            {altlogo}
            <Modal
              title="Ministry of Coin Login"
              wrapClassName="vertical-center-modal"
              visible={this.props.main.show_login_modal}
              onOk={() => { this.props.main.show_login_modal = false; }}
              onCancel={() => { this.props.main.show_login_modal = false; }}
              >
              <Button type="primary" icon="facebook" onClick={()=>{ this.props.main.auth('facebook'); }}>Login with Facebook</Button>
            </Modal>
          </Header>
          <Route path="/" component={Analytics} />
          <Route exact path="/" render={(match) => {
            this.props.history.push('/top');
            return null;
          }} />
          <Route path="/top" component={TopList} />
          <Route path="/market" component={Market} />
          <Route path="/exchange" component={Exchange} />
          <Route path="/fund" component={Fund} />
          <Footer className="main-footer">
            Ministry of Coin © 2017
            <Divider type="vertical" /><Link to="/__legal/privacy.html" target="_blank">Privacy</Link>
            <Divider type="vertical" /><Link to="/__legal/terms.html" target="_blank">Terms</Link>
            <Divider type="vertical" /><Link to="https://medium.com/ministryofcoin" target="_blank">Dev Blog</Link>
            <Divider type="vertical" /><Link to="https://www.reddit.com/r/MinistryOfCoin" target="_blank">/r/MinistryOfCoin</Link>
            <Divider type="vertical" /><Link to="https://twitter.com/ministryofcoin" target="_blank"><Icon type="twitter"/></Link>
            <Divider type="vertical" /><Link to="https://www.facebook.com/Ministry-of-Coin-162345657714072/" target="_blank"><Icon type="facebook"/></Link>
          </Footer>
        </Layout>
      </Layout>
    );
  }
}

export default withRouter(inject("main")(observer(App)));



// WEBPACK FOOTER //
// ./src/App.js